import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} className="w-full bg-black text-white py-3 px-4 text-center flex items-center justify-center gap-2 text-sm font-medium tracking-wide" data-id="element-76">
      <MapPinIcon className="w-4 h-4 text-white/80" data-id="element-77" />
      <span data-id="element-78">
        Beta Testers: 50 accesos disponibles a precio reducido.{' '}
        <span className="text-white/70 ml-1" data-id="element-79">[Quedan 12]</span>
      </span>
    </motion.div>;
}